var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWatermark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 375 480",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-110.128 650.749H44.7302L186.591 508.866L328.541 651H484.491L186.34 352.703L-110.128 650.749Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M484.491 -161.491H329.615L187.772 -19.6081L45.8223 -161.742H-110.128L188.023 136.555L484.491 -161.491Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M588.934 465.202V385.275L447.162 243.303L589.184 101.258V22.6211L511.487 22.9615L291.123 243.553L511.433 463.052L588.934 465.202Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-222.916 22.6211V102.566L-81.1446 244.539L-223.167 386.583V465.202L-145.451 464.88L74.913 244.288L-145.397 24.789L-222.916 22.6211Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWatermark);
export default __webpack_public_path__ + "static/media/watermark.944064d2c328c2f20a766697e8eec170.svg";
export { ForwardRef as ReactComponent };